import {ref, type Ref} from 'vue';

const intervalId: Ref<number | null> = ref(null);

export const startKeepAlive = () => {
    if (intervalId.value){
        clearInterval(intervalId.value);
        intervalId.value = null;
    }
    intervalId.value = setInterval(async () => {
        try {
            const response = await fetch('/ping', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    // 'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            });
        } catch (error) {
            console.error('Ping failed', error);
        }
    }, 30000);
};


